import { isIndividualAccountType, isJoinAccountType } from "../../../utils/account_types";
import { ENTITY_INSTRUCTIONS, INDIVIDUAL_INSTRUCTIONS, JOINT_INSTRUCTIONS } from "./constants";
import type { AccountTypeEnum } from "../../../graphql/supergraphTypes";

export const getRefreshInstructions = (
  accountType: AccountTypeEnum | null | undefined,
): readonly string[] => {
  if (isIndividualAccountType(accountType)) return INDIVIDUAL_INSTRUCTIONS;
  if (isJoinAccountType(accountType)) return JOINT_INSTRUCTIONS;
  return ENTITY_INSTRUCTIONS;
};
